import { ReactElement } from "react";

export default function SecondmentsIntro(): ReactElement {
  return (
    <div className="secondments-intro">
      <p>
        The WSG Secondment Program provides member firms and professionals the unique possibility to collaborate for a period of time through a firm exchange program that offers the opportunity to build stronger relationships, exchange information, gain experience, and increase local understanding and communications. Together, these advantages help members to better counsel clients, differentiate their service offerings and generate future business opportunities.
      </p>
    </div>
  );
}
